import { h } from '@seahax/elemental';

import { Icon } from '../components/icon.ts';
import { Title } from '../components/title.ts';
import { define } from '../utils/define.ts';
import style from './home.css?inline';

export const Root = define(
  (shadow) => {
    // prettier-ignore
    h(shadow, [
      h('div', { class: 'content' }, [
        h(Title),
        h('div', { class: 'links' }, [
          h('a', { class: 'link', href: 'https://sr.ht/~seahax/workshop/sources', target: '_blank' }, [
            h(Icon, { class: 'link-icon', 'icon-name': 'git' }),
            h('span', { class: 'link-label' }, ['Code']),
          ]),
          h('a', { class: 'link', href: 'https://musings.seahax.com/', target: '_blank' }, [
            h(Icon, { class: 'link-icon', 'icon-name': 'news' }),
            h('span', { class: 'link-label' }, ['Blog']),
          ]),
          h('a', { class: 'link', href: 'https://www.linkedin.com/in/ackermanchris', target: '_blank' }, [
            h(Icon, { class: 'link-icon', 'icon-name': 'linkedin' }),
            h('span', { class: 'link-label' }, ['Work']),
          ]),
          h('a', { class: 'link', href: 'mailto:chris@seahax.com' }, [
            h(Icon, { class: 'link-icon', 'icon-name': 'email' }),
            h('span', { class: 'link-label' }, ['Contact']),
          ]),
        ]),
      ]),
    ]);
  },
  { tagName: 'ce-root', styles: [style] },
);
